//首页视力数据
export const GET_VISION_DATA = "get_vision_data";
//请求首页视力
export const REQ_VISION_DATA = "req_vision_data";
//视力各模块的数据
export const GET_VISION_ITEM_DATA = "get_vision_item_data";
//请求视力各模块的数据
export const REQ_VISION_ITEM_DATA = "req_vision_item_data";
